<template>
  <div class="embassy-wrap">
    <div
      v-if="showFixedNav"
      class="tab fixed"
      :style="{ top: `${actualPageHeaderHeight}px` }"
    >
      <div class="tab-inner">
        <div
          v-for="item in tabList"
          :key="item.id"
          class="tab-item"
          :class="{ active: currentTab === item.id }"
          @click="handleTabTap(item.id)"
        >
          <div class="tab-text">{{ item.label }}</div>
          <div class="tab-bar"></div>
        </div>
      </div>
      <div class="tab-divider"></div>
    </div>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'EmbassyNoticeWrap',
  props: {
    interviewData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showFixedNav: false,
      currentTab: 'info',
    };
  },
  computed: {
    actualPageHeaderHeight() {
      return 0;
    },
    activeOffset() {
      return this.actualPageHeaderHeight + 40;
    },
    tabList() {
      const interviewData = this.interviewData || {};
      const list = [
        { id: 'info', label: '赴馆信息' },
        { id: 'material', label: '携带资料' },
      ];

      if (
        interviewData.need_delivery > 0 &&
        interviewData.tel_interview_notes &&
        interviewData.tel_interview_notes.length
      ) {
        list.push({ id: 'phone', label: '电话调查' });
      }

      list.push({
        id: 'process',
        label: interviewData.need_interview > 0 ? '面试流程' : '录指纹流程',
      });

      return list;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleTabTap(id) {
      if (!id) return;
      this.currentTab = id;
      const target = document.getElementById(id);
      if (!target) return;
      const rect = target.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      const targetTop = Math.max(0, rect.top + scrollTop - this.activeOffset);
      window.scrollTo({
        top: targetTop,
        behavior: 'smooth',
      });
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      this.showFixedNav = scrollTop > 10;
      const activeOffset = this.activeOffset + 5;
      const panels = Array.prototype.slice.call(
        document.querySelectorAll('.scroll-panel'),
      );
      if (!panels.length) return;

      const activePanel =
        panels
          .filter((panel) => panel.getBoundingClientRect().top <= activeOffset)
          .pop() || panels[0];
      if (activePanel && activePanel.id && activePanel.id !== this.currentTab) {
        this.currentTab = activePanel.id;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.embassy-wrap {
  min-height: 100vh;
  background: #f3f6f9;

  .tab {
    left: 0;
    right: 0;
    z-index: 90;
    height: 40px;
    background: #fff;
    box-shadow: 0 2px 4px 0 rgba(233, 238, 242, 0.8),
      0 4px 16px 0 rgba(233, 238, 242, 0.8);

    &.fixed {
      position: fixed;
    }
  }

  .tab-inner {
    display: flex;
    align-items: center;
    height: 40px;
  }

  .tab-item {
    box-sizing: border-box;
    flex: 1;
    min-width: 0;
    height: 40px;
    padding: 10px 12px 0;
    color: #666;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
  }

  .tab-item.active {
    color: #ff4b4d;
  }

  .tab-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .tab-bar {
    width: 100%;
    height: 2px;
    margin-top: 10px;
    background: #ff4b4d;
    opacity: 0;
  }

  .tab-item.active .tab-bar {
    opacity: 1;
  }

  .tab-divider {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 0.5px;
    background: #e6e9ed;
    transform: scaleY(0.5);
    transform-origin: left bottom;
  }
}
</style>
